export { default } from './SendTrackViewPageEvent.js';
